import { RestClient as RC } from '@ps-smart-cp/ppfw-client';

const faRestClient = new RC(process.env.ORIGIN_SERVER_URL);
const authRestClient = new RC(process.env.AUTH_ORIGIN_SERVER_URL, false);
const aiRestClient = new RC(process.env.INPUT_SUPPORT_ORIGIN_SERVER_URL!, false);

const RestClient = {
  fa: {
    get: faRestClient.get.bind(faRestClient),
    post: faRestClient.post.bind(faRestClient),
    formPost: faRestClient.formPost.bind(faRestClient),
    put: faRestClient.put.bind(faRestClient),
    delete: faRestClient.remove.bind(faRestClient),
    logError: faRestClient.logError.bind(faRestClient),
  },
  auth: {
    get: authRestClient.get.bind(authRestClient),
    post: authRestClient.post.bind(authRestClient),
    formPost: authRestClient.formPost.bind(authRestClient),
    put: authRestClient.put.bind(authRestClient),
    delete: authRestClient.remove.bind(authRestClient),
    logError: authRestClient.logError.bind(authRestClient),
  },
  inputSupport: {
    get: aiRestClient.get.bind(aiRestClient),
    post: aiRestClient.post.bind(aiRestClient),
    formPost: aiRestClient.formPost.bind(aiRestClient),
  },
};

export { RestClient };
